export default {"src":"/_next/static/media/medical-history.cd8f1835.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};